import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslationService } from '../../../services/translation-service.service';
import { LocalStorageKeys } from '../../../../constants/LocalStorageKeys';

@Component({
    selector: 'app-ledger-select-popover',
    templateUrl: './ledger-select-popover.component.html',
    styleUrls: ['./ledger-select-popover.component.scss'],
})
export class LedgerSelectPopoverComponent implements OnInit {

    //@Input() visibleLedgers: Array<Ledgers>;
    @Input() ts: TranslationService;
    @Input() TransactionType: number;

    Ledgers: any[] = [];

    constructor(private modalController: ModalController) { }

    ngOnInit() {
        var ledgers = JSON.parse(localStorage.getItem(LocalStorageKeys.Ledgers));

        this.Ledgers = ledgers.filter((x) => {
            if (x.TransactionTypes) {
                var ttype = JSON.parse(x.TransactionTypes);

                //2 Is replaced with 5
                if (ttype.indexOf(2) > -1)
                        ttype.push(5)

                return ttype.indexOf(this.TransactionType) > -1
            }

            return false;
        });
    }

    //cash() {
    //    this.selectLedger(Ledgers.Cash);
    //}

    //warranty() {
    //    this.selectLedger(Ledgers.Warranty);
    //}

    //internal() {
    //    this.selectLedger(Ledgers.Internal);
    //}

    //credit() {
    //    this.selectLedger(Ledgers.Credit);
    //}

    selectLedger(ledger) {
        this.modalController.dismiss(ledger);
    }

    //showCash() {
    //    return this.visibleLedgers.indexOf(Ledgers.Cash) > -1;
    //}

    //showWarranty() {
    //    return this.visibleLedgers.indexOf(Ledgers.Warranty) > -1;
    //}

    //showInternal() {
    //    return this.visibleLedgers.indexOf(Ledgers.Internal) > -1;
    //}

    //showCredit() {
    //    return this.visibleLedgers.indexOf(Ledgers.Credit) > -1;
    //}
}
